/** Parse Supabase Edge Function invoke errors into a readable message (includes JSON body when available). */
export const formatEdgeFunctionError = async (fnError: unknown): Promise<string> => {
  if (!fnError || typeof fnError !== 'object') {
    return String(fnError ?? 'Unknown error');
  }
  const err = fnError as { message?: string; context?: Response };
  const base = typeof err.message === 'string' ? err.message : 'Edge Function error';

  try {
    if (err.context && typeof err.context.json === 'function') {
      const body = (await err.context.json()) as unknown;
      if (body && typeof body === 'object' && 'error' in body) {
        const detail = (body as { error?: unknown; details?: unknown }).error;
        const details = (body as { details?: unknown }).details;
        const extra = details !== undefined ? ` ${JSON.stringify(details)}` : '';
        return `${base}: ${String(detail)}${extra}`;
      }
      return `${base}: ${JSON.stringify(body)}`;
    }
  } catch {
    // ignore parse failures
  }

  return base;
};

export const throwEdgeFunctionError = async (fnError: unknown): Promise<never> => {
  throw new Error(await formatEdgeFunctionError(fnError));
};
